angular.module('Itao.IndicatorMap').directive('exportPreview', ['mapConfig', 'ExportService', 'ModalService', function (mapConfig, ExportService, ModalService) {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'exportPreview.html',
    scope: {
      types: '=',
      filename: '@',
      source: '@',
      config: '='
    },
    link: function (scope, element) {
      // default lm-source
      var $contentContainer = jQuery('.itao-pluginView:first');
      scope.exportPreview = function () {
        ModalService.createCustomModal({
          types: scope.types,
          source: scope.source,
          config: scope.config
        }, {
          templateUrl: MAP_TEMPLATE_BASE_PATH + 'modals/exportPreview.html',
          controller: 'ExportPreviewModalController',
          size: 'xl',
          backdrop: 'static',
          keyboard: false
        })
      };

      var exportWidget = function (type, html, source, dimensions) {
        if(type == 'csv') {
          ExportService.exportAsCsv(
            scope.data,
            type,
            scope.filename
          );
        } else if (type == 'xlsx') {
          ExportService.exportAsXlsx(
            scope.data,
            type,
            scope.filename
          );
        } else if (type == 'pdf') {
          ExportService.exportAsPdf(
            html,
            scope.filename,
            dimensions,
            source
          );
        } else {
          ExportService.exportAsImage(
            html,
            type,
            scope.filename,
            dimensions,
            source
          );
        }
      };

      scope.htmlToPdf = function (id) {
        var $contentContainer = jQuery('#' + id);
        ExportService.exportAsPdf(
          $contentContainer[0].outerHTML,
          scope.filename,
          [Math.ceil($contentContainer.width()), Math.ceil($contentContainer.height())],
          '<div class="source"><b>Quelle:</b> Ländermonitor Frühkindliche Bildungssysteme, www.laendermonitor.de</div>'
        );
      }
    }
  };
}]);
